import { AxiosInstance } from 'axios'

export function getCommonAnalytics(
  api: AxiosInstance
): Promise<DashboardCommonAnalytics> {
  return api.get('/v1/admin/stats')
}
